export default "__VITE_ASSET__ChEAmrTY__"